module.exports = __webpack_public_path__ + "static/media/mailnews_2.563e5cd3.ico";